import { render, staticRenderFns } from "./CostoItem.vue?vue&type=template&id=216bab9e&"
import script from "./CostoItem.vue?vue&type=script&lang=js&"
export * from "./CostoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports